import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { observer } from "mobx-react-lite";
import { Box, Grid, Typography } from "@mui/material";

import { StatusShipment } from "../../app/util/constants";

import { RootStoreContext } from "../../app/store/root";

const InfoGeneralEnvios = (props) => {
  const { tipo } = props;
  const rootStore = useContext(RootStoreContext);
  const { entity } = rootStore.shipmentStore;

  /* UseStates */
  const [status, setStatus] = useState("");
  /* End UseStates */

  useEffect(() => {
    if (entity && Object.keys(entity).length > 0) {
      const estatus = StatusShipment.find(
        (x) => Object.entries(x)[0][1] === entity.idEstatus
      );
      if (estatus) setStatus(Object.entries(estatus)[0][0]?.replace("_", " "));
    }
  }, [entity]);

  return (
    <Box>
      <Typography variant="h6" color={"primary.main"}>
        Información general
      </Typography>
      <Grid container direction={"row"} spacing={1} mt={1}>
        <Grid item sm={3} xs={6} container direction={"column"}>
          <Typography variant="labelBold">No. de guía</Typography>
          <Typography variant="subtitle">{entity?.numeroGuia}</Typography>
        </Grid>
        <Grid item sm={3} xs={6} container direction={"column"}>
          <Typography variant="labelBold">Fecha de creación de guía</Typography>
          <Typography variant="subtitle">
            {entity?.fechaCreo
              ? moment(new Date(entity?.fechaCreo)).format("DD/MM/YYYY hh:mm A")
              : ""}
          </Typography>
        </Grid>
        <Grid item sm={3} xs={6} container direction={"column"}>
          <Typography variant="labelBold">Destino de envío</Typography>
          <Typography variant="subtitle">{entity?.destino}</Typography>
        </Grid>
        <Grid item sm={3} xs={6} container direction={"column"}>
          <Typography variant="labelBold">Último estatus</Typography>
          <Typography variant="estatus" color={"entregado.main"}>
            {status}
          </Typography>
          <Typography variant="subtitle">
            {entity?.fechaEstatus
              ? moment(new Date(entity?.fechaEstatus)).format(
                  "DD/MM/YYYY hh:mm A"
                )
              : ""}
          </Typography>
        </Grid>
        {tipo === 1 && (
          <React.Fragment>
            <Grid item sm={3} xs={6} container direction={"column"}>
              <Typography variant="labelBold">No. de carta porte</Typography>
              <Typography variant="subtitle">
                {entity?.numeroCartaPorte}
              </Typography>
            </Grid>
            <Grid item sm={3} xs={6} container direction={"column"}>
              <Typography variant="labelBold">Empresa</Typography>
              <Typography variant="subtitle">{entity?.proveedor}</Typography>
            </Grid>
            <Grid item sm={3} xs={6} container direction={"column"}>
              <Typography variant="labelBold">Detalles del envío</Typography>
              <Typography variant="subtitle">
                {entity?.descripcionEnvio}
              </Typography>
            </Grid>
          </React.Fragment>
        )}
        {tipo === 2 && (
          <React.Fragment sx={{ paddingLeft: "8px" }}>
            <Grid item sm={3} xs={6} container direction={"column"}>
              <Typography variant="labelBold">No. de embarque</Typography>
              <Typography variant="subtitle">235634783</Typography>
            </Grid>
            <Grid item sm={3} xs={6} container direction={"column"}>
              <Typography variant="labelBold">Detalles del envío</Typography>
              <Typography variant="subtitle">Detalles...</Typography>
            </Grid>
          </React.Fragment>
        )}
      </Grid>
    </Box>
  );
};

export default observer(InfoGeneralEnvios);
